export const EXTERNAL_ROUTES = {
  dakBgmEve: 'https://www.dak.de/dak/einverstaendniserklaerung-2450448.html#/',
  facebook: 'https://www.facebook.com/Balloon/',
  instagram: 'https://www.instagram.com/balloon_meditation/',
  openBalloonApp: 'https://www.balloonapp.de/view/course/2C4CCA94B046CE2D755AEA5A14CA1C54D78F82A726E2070246345EA3484023E8',
  othersEve:
    'https://einverstaendniserklaerung.dak.de/prweb/EVE?pyActivity=Data-Portal.SetHashAndShowPortal&hvalue=OL45DA3FEDB0EF5C7520BDA985A65305CA',
  youtube: 'https://www.youtube.com/channel/UC9gwE0T4ZJAxCekCbeFDgjA',
  google: 'https://play.google.com/store/apps/details?id=com.greenhouse.balloon',
  apple: 'https://apps.apple.com/de/app/balloon-meditation/id1259131200'
};
